/**
 * External Dependencies
 */
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
// import 'jquery';

import * as Utility from './utility';

Utility.ready(() => {

  // Bootstrap components
  [].slice.call(document.querySelectorAll('.dropdown-toggle')).map(function (dropdownTriggerEl) {
    return new Dropdown(dropdownTriggerEl);
  });

  const gameModalEl = document.getElementById('gameModal');
  if (gameModalEl) {
    let resumeGame = false;
    const gameModal = new Modal(gameModalEl, {
      keyboard: false
    });
    //@ts-ignore
    [].slice.call(document.querySelectorAll('[data-bs-toggle="modal"]')).map(function (modalTriggerEl) {
      modalTriggerEl.onclick = function openModal() {
        if (resumeGame) {
          return gameModal.toggle();
        }

        const gameUrl = modalTriggerEl.getAttribute('data-src');

        gameModalEl.firstElementChild.firstElementChild.insertAdjacentHTML('beforeend', `
          <iframe src="${gameUrl}" class="overflow-hidden" name="gameSource" scrolling="no" height="100%" width="100%" frameborder="0" allowtransparency="true" allow="autoplay; fullscreen; camera; focus-without-user-activation *;" allowfullscreen="allowfullscreen"></iframe>
          <button type="button" class="btn-dark position-absolute rounded-end start-0 top-0 mt-4 p-2 ps-0" data-bs-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
              <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
            </svg>
            <img width="30" height="30" src="https://www.egierki.pl/app/uploads/2020/05/favicon.png" loading="lazy" alt="egierki kulki favicon">
          </button>
        `);
        modalTriggerEl.innerHTML = 'Graj dalej';
        return gameModal.toggle();
      }
    });

    gameModalEl.addEventListener('hidden.bs.modal', function (event) {
      resumeGame = true;
    })
  }

  // EG Rating
  [].slice.call(document.querySelectorAll('.eg-rating')).map(function (ratingTriggerEl) {
    ratingTriggerEl.onclick = function openModal() {
      console.log('rating clicked!!!');
    };
  });

  //DELAY EXTRA SCRIPTS
  const autoLoadDuration = 3; //In Seconds
  const eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];

  const autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);

  eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true })
  });

  function triggerScripts() {
    runScripts();
    clearTimeout(autoLoadTimeout);
    eventList.forEach(function(event) {
      window.removeEventListener(event, triggerScripts, { passive: true });
    });
  }

  function runScripts() {
    document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
      scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
    });
  }
});
